import React from "react";
import logo from "./logo.svg";
import Layout, { CAPABILITIES_LOOKUP, TAB_LOOKUP } from "./Layout";
import image from "./images/virtual-coworkers.jpg";
import ArrowButton from "./ArrowButton";
import Lottie from "react-lottie";
// If there are images, use the converted json (index.js)
import animationData from "./lottie/storyboard12/data.json";
import "./Capabilities10InsightsAnalyticsScreen.scss";
import { t } from "i18next";

function Capabilities10InsightsAnalyticsScreen() {
  return (
    <div className="capabilities-screen fill-absolute">
      <div className="container full-height row" style={{ marginTop: 60 }}>
        <div className="challenges-image full-height padding flex">
          <Lottie
            options={{
              animationData,
            }}
          />
          {/* <img
            src={image}
            style={{ width: "95%" }}
            alt="profile on a phone with a green mark"
          /> */}
        </div>
        <div className="full-height padding flex vertical-center">
          <h2 className="green-header">
            {t("Capability10.title")} &amp; {t("Capability10.title2")}{" "}
          </h2>
          <p>{t("Capability10.section1")}</p>
          <p>{t("Capability10.section2")}</p>
          <p>{t("Capability10.section3")}</p>
          <div style={{ height: 60 }} />
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/capabilities-collaboration" side="left"></ArrowButton>
        <ArrowButton to="/partner-ecosystem" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities10InsightsAnalyticsScreen;
